import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { ErrorResponse } from '../../models/error.model';
import { MessageResponse } from '../../models/message.model';
import { TokenExtendResponse, TokenRefreshResponse, TokenResponse, TokenSwitchResponse } from '../../models/token.model';
import { User } from '../../models/user.model';
import { AppService } from '../../models/app.service.model';
import { authToken } from '../../scripts/authentication.script';

export class ApiDigitalAuthAuthentication {
  static apiResponse: ApiResponse

  public static async login(
    api_key: string,
    email: string,
    password: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let users: User[] | null = null
      let tokenResponse: TokenResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/users.data.json').then(response => { users = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/token.data.json').then(response => { tokenResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (users!.some(item => item.email === email && item.password === password)) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: tokenResponse!.success === true ? tokenResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/auth/login`

      let data: any = {
        email: email,
        password: password
      }

      await axios.post(url, data).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data.success === true ? response.data.data : null
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.success === false ? error.response.data.error : null
        }
      })
    }

    return this.apiResponse
  }

  public static async refresh(
    api_key: string,
    token_refresh: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let tokenRefreshResponse: TokenRefreshResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/token.refresh.data.json').then(response => { tokenRefreshResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (tokenRefreshResponse!.data.refresh_token === token_refresh) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: tokenRefreshResponse!.success === true ? tokenRefreshResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/auth/refresh`

      let data: any = {
        refresh_token: token_refresh
      }

      await axios.post(url, data).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data.success === true ? response.data.data : null
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.success === false ? error.response.data.error : null
        }
      })
    }

    return this.apiResponse
  }

  public static async logout(
    api_key: string,
    token_refresh: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let appServices: AppService[] | null = null
      let messageResponse: MessageResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/system.apps.data.json').then(response => { appServices = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { messageResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (appServices!.some(item => item.api_key === api_key) && token_refresh.length) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: messageResponse!.success === true ? messageResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/auth/logout`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      let data: any = {
        refresh_token: token_refresh
      }

      await axios.post(url, data, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data.success === true ? response.data.data : null
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.success === false ? error.response.data.error : null
        }
      })
    }

    return this.apiResponse
  }

  public static async logoutAll(
    api_key: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let appServices: AppService[] | null = null
      let messageResponse: MessageResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/system.apps.data.json').then(response => { appServices = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { messageResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (appServices!.some(item => item.api_key === api_key)) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: messageResponse!.success === true ? messageResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/auth/logout-all`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.post(url, null, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data.success === true ? response.data.data : null
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.success === false ? error.response.data.error : null
        }
      })
    }

    return this.apiResponse
  }

  public static async register(
    api_key: string,
    first_name: string,
    last_name: string,
    email: string,
    phone: string,
    password: string,
    password_confirmation: string,
    locale: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let users: User[] | null = null
      let tokenResponse: TokenResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/users.data.json').then(response => { users = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/token.data.json').then(response => { tokenResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (!users!.some(item => item.first_name === first_name && item.last_name === last_name && item.email === email && item.phone === phone)) {
        this.apiResponse = {
          status: 201,
          message: 'Success',
          data: tokenResponse!.success === true ? tokenResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/auth/register`

      let data: any = {
        first_name: first_name,
        last_name: last_name,
        email: email,
        phone: phone,
        password: password,
        password_confirmation: password_confirmation,
        locale: locale
      }

      await axios.post(url, data).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data.success === true ? response.data.data : null
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.success === false ? error.response.data.error : null
        }
      })
    }

    return this.apiResponse
  }

  public static async registerInvitation(
    api_key: string,
    token: string,
    email: string,
    first_name: string,
    last_name: string,
    phone: string,
    password: string,
    password_confirmation: string,
    locale: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let users: User[] | null = null
      let tokenResponse: TokenResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/users.data.json').then(response => { users = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/token.data.json').then(response => { tokenResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (!users!.some(item => item.first_name === first_name && item.last_name === last_name && item.phone === phone)) {
        this.apiResponse = {
          status: 201,
          message: 'Success',
          data: tokenResponse!.success === true ? tokenResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/auth/register-with-invitation`

      let data: any = {
        token: token,
        email: email,
        first_name: first_name,
        last_name: last_name,
        phone: phone,
        password: password,
        password_confirmation: password_confirmation,
        locale: locale
      }

      await axios.post(url, data).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data.success === true ? response.data.data : null
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.success === false ? error.response.data.error : null
        }
      })
    }

    return this.apiResponse
  }

  public static async registerExtend(
    api_key: string,
    email: string,
    password: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let users: User[] | null = null
      let tokenExtendResponse: TokenExtendResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/users.data.json').then(response => { users = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/token.extend.data.json').then(response => { tokenExtendResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (users!.some(item => item.email === email && item.password === password)) {
        this.apiResponse = {
          status: 201,
          message: 'Success',
          data: tokenExtendResponse!.success === true ? tokenExtendResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/auth/register/extend`

      let data: any = {
        email: email,
        password: password
      }

      await axios.post(url, data).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data.success === true ? response.data.data : null
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.success === false ? error.response.data.error : null
        }
      })
    }

    return this.apiResponse
  }

  public static async resendVerification(
    api_key: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let appServices: AppService[] | null = null
      let messageResponse: MessageResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/system.apps.data.json').then(response => { appServices = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { messageResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (appServices!.some(item => item.api_key === api_key)) {
        this.apiResponse = {
          status: 201,
          message: 'Success',
          data: messageResponse!.success === true ? messageResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/auth/resend-verification`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.post(url, null, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data.success === true ? response.data.data : null
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.success === false ? error.response.data.error : null
        }
      })
    }

    return this.apiResponse
  }

  public static async verifyEmail(
    api_key: string,
    token_verification: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let user: User | null = null
      let messageResponse: MessageResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/user.data.json').then(response => { user = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { messageResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (user!.verification_token === token_verification) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: messageResponse!.success === true ? messageResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/auth/verify-email`

      let data: any = {
        verification_token: token_verification 
      }

      await axios.post(url, data).then( response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data.success === true ? response.data.data : null
        }
      }).catch( error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.success === false ? error.response.data.error : null
        }
      })
    }

    return this.apiResponse
  }

  public static async switchCompany(
    api_key: string,
    token_refresh: string,
    company_id: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let tokenSwitchResponse: TokenSwitchResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/token.switch.data.json').then(response => { tokenSwitchResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (tokenSwitchResponse!.data.refresh_token === token_refresh) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: tokenSwitchResponse!.success === true ? tokenSwitchResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/auth/switch-company`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      let data: any = {
        company_id: company_id,
        refresh_token: token_refresh
      }

      await axios.post(url, data, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data.success === true ? response.data.data : null
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.success === false ? error.response.data.error : null
        }
      })
    }

    return this.apiResponse
  }
}
